import React, { useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import { PropagateLoader } from "react-spinners";
import { MdDelete, MdEdit } from "react-icons/md";
import { FaArrowRight } from "react-icons/fa";
import NoData from "../../atoms/NoData";
import Button from "../../atoms/Button";
import Modal from "../../molecules/Modal";
import ModalConfirm from "../../molecules/ModalConfirm";
import ModalEditEnterprise from "../clientes/empresas/ModalEditEnterprise";
import useModal from "../../../hooks/useModal";
import { DELETE_ENTERPRISE } from "../../../api/apiEmpresas";
import { getRegimen } from "../../../data/regimenFiscalData";
import { getResponsibleName } from "../../../functions/getNames";
import { getConditionalRowStyles } from "../../../styles/expandedStyles";

const EmpresaListTable = ({ data, loading, accountants, refetch, admins }) => {
    const navigate = useNavigate();
    const [empresa, setEmpresa] = useState();
    const { open, close, isOpen } = useModal();
    const { open: openDelete, close: closeDelete, isOpen: isOpenDelete } = useModal();
    const [expandedRow, setExpandedRow] = useState(null);

    const handlePush = (id) => {
        navigate(`/clientes/empresas/${id}/decide`);
    };

    const handleOpenEdit = (empresa) => {
        setEmpresa(empresa);
        open();
    };

    const handleOpenDelete = (empresa) => {
        openDelete();
        setEmpresa(empresa);
    };

    const handleDelete = async () => {
        try {
            await DELETE_ENTERPRISE(empresa.id);
            toast.success("Eliminado correctamente");
            closeDelete();
            refetch();
        } catch (error) {
            console.error(error);
            toast.error("Error al eliminar");
        }
    };

    const columns = [
        { name: "Empresa", cell: row => (
            <div className="flex flex-col my-1 gap-1">
                <p className="text-blue-700 bg-blue-100 p-1 rounded-lg w-fit font-semibold"> {row.name}  </p>
                <p className="text-orange-700 bg-orange-100 p-1 rounded-lg w-fit font-semibold"> Regimen: {row.type === "LegalEntitie" ? "PERSONA MORAL" : "PERSONA FISICA"} </p>
                <p className="text-gray-700 bg-gray-100 p-1 rounded-lg w-fit font-semibold">{row.rfc}</p>
            </div>
            ), 
        },
        { name: "Información", cell: row => (
            <div className="flex flex-col my-1 gap-1">
                <p className="text-rose-700 bg-rose-100 p-1 rounded-lg w-fit font-semibold"> Contador: {getResponsibleName(row, accountants, admins)} </p>
                {row.isAccountingClient && <p className="text-purple-700 bg-purple-100 p-1 rounded-lg w-fit font-semibold">Cliente de contabilidad</p>}
                {row.isTaxDefenseClient && <p className="text-green-700 bg-green-100 p-1 rounded-lg w-fit font-semibold">Cliente de defensa fiscal</p>}
            </div>
            ),
        },
        { name: "Acciones", cell: row => (
            <div className="flex flex-row space-x-4">
                <Button text={<MdEdit size={22}/>} bgColor="blue" width="w-10" onClick={()=> handleOpenEdit(row)}/>
                <Button text={<MdDelete size={22}/>} bgColor="red" width="w-10" onClick={()=> handleOpenDelete(row)}/>
                <Button text={<FaArrowRight size={22} />} bgColor="orange" width="w-10" onClick={()=> handlePush(row.id)} />
            </div>
            ),
            width: "250px"
        },
    ];

    const columnsResponsive = [
        { name: "Información", cell: row => (
            <div className="flex flex-col">
                <p> {row.name}  </p>
                <p>{row.rfc}</p>
                <p> {row?.name_rl ? `RL ${row.name_rl}` : null} </p>
                <p> Regimen: {row.type === "LegalEntitie" ? "PERSONA MORAL" : "PERSONA FISICA"} </p>
                <p>Regimen fiscal: {getRegimen(row.c_RegimenFiscal)}</p>
                <p> Contador: {getResponsibleName(row, accountants, admins)} </p>
            </div>
            ),
        },
    ];

    const ExpandedComponent = ({ data }) => (
        <div className="p-2 w-full flex flex-row justify-around">
            <Button
                text={<MdEdit size={22} />}
                bgColor="blue"
                width="w-10"
                onClick={() => handleOpenEdit(data)}
            />
            <Button
                text={<MdDelete size={22} />}
                bgColor="red"
                width="w-10"
                onClick={() => handleOpenDelete(data)}
            />
            <Button text={<FaArrowRight size={22} />} bgColor="orange" width="w-10" onClick={()=> handlePush(data.id)} />
        </div>
    );

    const conditionalRowStyles = getConditionalRowStyles(expandedRow);

    return(
        <div>
            <div className="block md:hidden">
                <DataTable
                    data={data}
                    progressPending={loading}
                    columns={columnsResponsive}
                    progressComponent={
                        <div className="w-full h-20 flex justify-center items-center">
                            <PropagateLoader color="red" />
                        </div>
                    }
                    noDataComponent={<NoData/>}
                    pagination
                    responsive
                    expandableRows
                    expandableRowsComponent={ExpandedComponent}
                    expandableRowExpanded={(row) => row?.id === expandedRow?.id}
                    onRowExpandToggled={(expanded, row) => {
                        setExpandedRow(expanded ? row : null);
                    }}
                    conditionalRowStyles={conditionalRowStyles}
                />
            </div>
            <div className="hidden md:block">
                <DataTable
                    data={data}
                    progressPending={loading}
                    columns={columns}
                    progressComponent={
                        <div className="w-full h-20 flex justify-center items-center">
                            <PropagateLoader color="red" />
                        </div>
                    }
                    noDataComponent={<NoData/>}
                    pagination
                />
            </div>
            {isOpen &&
                <Modal onClose={close} title="Editar empresa" >
                    <ModalEditEnterprise onClose={close} refetch={refetch} empresa={empresa} />
                </Modal>
            }
            {isOpenDelete &&
                <ModalConfirm onClose={closeDelete} onConfirm={handleDelete} eliminacion />
            }
        </div>
    );
};

export default EmpresaListTable;